import { apiFetch } from '../apiFetch'

export const getAssets = async (id) => {
  return await apiFetch({
    path: '/assets'
  })
}

export const postAsset = async (payload) => {
  return await apiFetch({
    method: 'POST',
    path: '/assets',
    payload
  })
}

export const deleteAsset = async (payload) => {
  return await apiFetch({
    method: 'DELETE',
    path: '/assets',
    payload
  })
}
